<template>
    <div class="magazine-header">
        <div class="magazine-header__image" :style="{ backgroundImage: `url(${image})` }">
            <h1 class="magazine-header__title">{{ title }}</h1>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MagazineHeader',
    props: {
        image: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

.magazine-header {
    width: 100%;
    height: 25vw;
    min-height: 115px;
    max-height: 368px;
    position: relative;

    &__image {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background: linear-gradient(359deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
            z-index: 1;
        }
    }

    &__title {
        @extend %heading-1;
        color: $white;
        z-index: 2;
        margin: 0 16px;
    }
}
</style>
